import styled from '@emotion/styled';
import { getColor } from '../UICommon';
import { TabletWidth } from '../../../global.style';

export const SuggestOffer = styled.div<{ showPlan: boolean }>`
  background-color: ${getColor('LIGHT_CREAM')};
  border-radius: 600px;
  border: ${({ showPlan }) => (showPlan ? '' : `1.5px solid ${getColor('GRAY_80')}`)};
  width: 327px;
  display: flex;
  flex-direction: column;
  align-items: ${({ showPlan }) => (showPlan ? '' : 'center')};
  color: ${({ showPlan }) => (showPlan ? '' : `${getColor('GRAY_80')}`)};
  align-self: stretch;
  cursor: pointer;
  padding: 6px 12px;
  text-decoration-line: ${({ showPlan }) => (showPlan ? 'underline' : 'none')};
  @media (max-width: ${TabletWidth}px) {
    margin: auto;
  }
`;
